import React from "react";

import {AddDailyItemData, PartialOrder} from "@apps/daily-menu/interfaces";
import moment from "moment";

import {IMAGE_SIZES} from "@globals/functions/getResolutionImgUrl";
import {useUser} from "@globals/user";

import {DishDetailsConfigProvider} from "@components/DishDetails";
import {MenuRowSkeleton} from "@components/LoadingSkeleton";
import {Menu, MenuType} from "@components/Menu/interfaces";
import MenuItem from "@components/MenuItem";
import NomiconIcon from "@components/NomiconIcon";

import BrandHeader from "../BrandHeader";
import getBrandDishesImageSize from "../utils/getBrandDishesImageSize";
import styles from "./UpcomingDishes.scss";

export type UpcomingDishesProps = {
  brandMenus: Menu[];
  hasNoUpcomingDishes: boolean;
  addItem: (itemData: AddDailyItemData) => Promise<PartialOrder>;
  isLoading?: boolean;
  isError: boolean;
};

export default function UpcomingDishes({
  brandMenus,
  hasNoUpcomingDishes,
  addItem,
  isLoading = false,
  isError,
}: UpcomingDishesProps): JSX.Element {
  const {isAuthorized} = useUser();

  if (!isLoading && hasNoUpcomingDishes && isError) {
    return <></>;
  }

  return (
    <section
      className={styles.upcomingDishesWrapper}
      aria-labelledby="upcoming-dishes-header"
    >
      <BrandHeader id="upcoming-dishes-header">Upcoming Dishes</BrandHeader>
      {isLoading && <MenuRowSkeleton />}
      {isLoading ||
        brandMenus.map((brandMenu) => {
          const dishes = Object.values(brandMenu.items);
          return (
            <div
              className={styles.upcomingDishesContainer}
              key={`dishes-${brandMenu.id}`}
            >
              <h4 className={styles.menuDate}>
                <NomiconIcon
                  icon="nomicon-calendar"
                  className={styles.calendarIcon}
                />
                <span>{moment(brandMenu.date).format("ddd M/D")}</span>
              </h4>

              <DishDetailsConfigProvider
                showFavorites={isAuthorized}
                showFavoriteHoverBox={true}
                showReviews
                menuType={MenuType.Individual}
                showPriceInPurchaseButton
                hidePriceInDishDetails
                addButtonText={"Add"}
                selectedDate={brandMenu.date}
                changeItemQty={addItem}
              >
                <div className={styles.dishes}>
                  {dishes?.map((dish) => (
                    <div key={dish.id} className={styles.dishItemContainer}>
                      <MenuItem
                        wrapperClassName={styles.dishItemWrapper}
                        item={dish}
                        imageSize={IMAGE_SIZES.DAILY_MENU}
                        sizesAttribute={getBrandDishesImageSize()}
                      />
                    </div>
                  ))}
                </div>
              </DishDetailsConfigProvider>
            </div>
          );
        })}

      {!isLoading && hasNoUpcomingDishes && (
        <div>Sorry, no upcoming dishes available.</div>
      )}
    </section>
  );
}
